import axios from "axios";
import { getToken } from "./lib/auth";

/** Axios client for the LCDS admin API (base URL from REACT_APP_API_URL). */
const httpClient = () => {
	const client = axios.create({
		baseURL: process.env.REACT_APP_API_URL,
		headers: { Accept: "application/json", "Content-Type": "application/json" },
	});
	client.interceptors.request.use((config) => {
		const token = getToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});
	return client;
};

export default httpClient;
